// react
import React, { useEffect, useContext } from 'react';
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// material-ui components
import TextField from '@material-ui/core/TextField';
import FormHelperText from "@material-ui/core/FormHelperText";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import {MaskMoney, transformValueFormatedtoFloat} from "beaktShared/helpers/masks";
import { UseGetApiSimple } from "beaktShared/services/crudeApiService";

// services
import { SessionContext } from "beaktShared/services/session";

// style
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/BeaktClinic/views/Venda/pagamentoCartao.js";
const useStyles = makeStyles(styles);

export default function PedidoCompraPagamentoDeposito({ pgto, CallloadTotalizadorPgtos }) {
  const { t } = useTranslation();
  const classes = useStyles();
  const session = useContext(SessionContext);
  const { register, errors, handleSubmit, setValue} = useForm({mode: "onBlur"});   

  const [messageReturn,setmessageReturn]= React.useState({
    show:false,
    message:''
  });
  
  const clearForm = () =>{
    setValue("valor","");    
  }  

  const [contaDeposito, setcontaDeposito] = React.useState([]);
  const loadContaDeposito = () => {      
      let endPoint = "franquias/getcontadeposito/"+session.estabelecimentoId;        
      UseGetApiSimple(endPoint, 0).then(result => {
      if (result.status !== 200) {
          setcontaDeposito({
            agencia: "",
            conta: "",
            banco: ""
          })          
          return false;
      }             
      setcontaDeposito(result.data);
      return true;
      });
  }

  useEffect(() => {       
    loadContaDeposito();
  }, []);    


  const onSubmit = (data, e) => {
    e.preventDefault();
        
    let valor = transformValueFormatedtoFloat(data.valor);
    if(valor > pgto.totalizadorPagamentos.valorPendente)
    {
      setmessageReturn({
        show:true,
        message:t('error_message.the_amount_must_be_equal_or_less_than_the_balance_to_pay')
      });          
      return false;
    }

    if (valor === 0){
        setmessageReturn({
            show:true,
            message:t('error_message.the_value_must_be_greater_than_0')
          });          
          return false;
    }
        
    let pg = {
      id:pgto.pedidoCompraPagamentoDepositos.length+1,      
      valor:valor,      
    }

    let updatepgto ={
      ...pgto,        
      pedidoCompraPagamentoDepositos:[
        ...pgto.pedidoCompraPagamentoDepositos,
        pg
      ]
    };

    clearForm();
    setmessageReturn({show:false})    
    CallloadTotalizadorPgtos(updatepgto);   
    return true;
  }

return (
    <div>    
      
      <form onSubmit={handleSubmit(onSubmit)}>   
                            
        <GridContainer className={classes.containerin}>
            <GridItem xs={12} sm={3} md={4}>
            <div className={classes.labelIdent}>
              {t('label.value')} *
            </div>
            </GridItem>      
            <GridItem xs={12} sm={4} md={3}>  
            <TextField
                fullWidth
                variant="outlined"
                InputLabelProps={{shrink: true}} 
                defaultValue=""  
                name="valor"                        
                InputProps={{ inputComponent: MaskMoney}}    
                inputRef={register({required: true})}
                error={errors.valor?true:false} 
            />
            <FormHelperText>
                {errors.valor && <span className="obg">{t('label.required')}</span>}
            </FormHelperText>   
        </GridItem>        
      </GridContainer>
      <GridContainer className={classes.containerin}>
      <GridItem xs={12} sm={12} md={12}>
          <center>            
            <label>{t('label.agency')}:{contaDeposito.agencia} | {t('label.account')}: {contaDeposito.conta} | {t('label.bank')}: {contaDeposito.banco}</label>
          </center>
          <br/>
        </GridItem>      
      </GridContainer>
      <GridContainer className={classes.containerin}>
            <GridItem xs={12} sm={12} md={12}>            
                {messageReturn.show &&
                    <div><div className="alertErrorEx alertmax">
                    <p>
                    {messageReturn.message}   
                    </p>
                    </div><br/></div>
                }
                <center>
                <Button type="submit" color="primary" >
                {t('button.post_payment')}                    
                </Button>                
                </center>
            </GridItem>
      </GridContainer>
    </form>

  </div>
);
}